import { useParams } from '@remix-run/react'
import type { AppLanguages, AppLocales } from '@constants/i18n'
import {
  APP_LANGUAGES,
  APP_LOCALES,
  DEFAULT_LANGUAGE,
  DEFAULT_LOCALE,
} from '@constants/i18n'
import { arrayIncludes } from '@helpers/arrayIncludes'

export function useGetLocaleFrom404() {
  const parms = useParams()
  const url = parms['*']
  const locale = url?.substring(0, 5)
  const language = url?.substring(0, 2)

  type Output = {
    locale: AppLocales
    language: AppLanguages
  }
  const output: Output = { locale: DEFAULT_LOCALE, language: DEFAULT_LANGUAGE }

  if (locale && arrayIncludes(APP_LOCALES, locale)) {
    output.locale = locale
  }

  if (language && arrayIncludes(APP_LANGUAGES, language)) {
    output.language = language
  }

  return output
}
